<template>
  <v-form v-model="valid" ref="uploadFile">
    <v-card-text>

      <v-text-field
          v-model="fileName"
          :label="`${$t('archive.choose_file')}`"
          prepend-icon="attach_file"
          @click="onPickFile"
      ></v-text-field>
      <!-- Hidden -->
      <input
          ref="fileInput"
          accept="*/*"
          style="display: none"
          type="file"
          @change="onFilePicked">

      <v-text-field
          v-model="name"
          :label="`${$t('archive.file-name')}`"
          :rules="nameRules"
          required
          width="80%"
      ></v-text-field>
      <v-text-field
          v-model="archType"
          :label="`${$t('archive.arch_type')}`"
          width="80%"
      ></v-text-field>
      <v-textarea
          v-model="note"
          :label="`${$t('archive.note')}`"
          clear-icon="cancel"
          clearable
          required
      ></v-textarea>
    </v-card-text>

    <v-divider></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>

      <v-progress-circular
          v-if="loading"
          color="primary"
          indeterminate
          spacing="pr-4"
      ></v-progress-circular>
      <v-btn color="primary" @click="upload" :disabled="loading">
        {{ $t('archive.upload') }}
      </v-btn>
    </v-card-actions>
  </v-form>
</template>

<script>
import http from '@/plugins/http'

export default {
  data() {
    return {
      fileName: '',
      url: '',
      fileObject: null,
      cardResult: '',
      name: '',
      size: '',
      note: '',
      archType: '',
      type: '',
      lastModifiedDate: '',
      loading: false,
      valid: false,
      nameRules: [
        (v) => (!v || v.length >= 2) || this.$t('team.create.error.min-length-3'),
        (v) => !!v || this.$t('team.create.error.no-name-msg'),
        (v) => /[A-ZĄĆĘŁŃÓŚŹŻ]/.test(v.charAt(0).toUpperCase()) || this.$t('team.create.error.first-letter-msg'),
      ]
    }
  },
  computed: {
    teams() {
      return this.$store.state.teams
    }
  },
  methods: {
    onPickFile() {
      this.$refs.fileInput.click()
    },
    onFilePicked(event) {
      const files = event.target.files
      if (files[0] !== undefined) {
        this.fileName = files[0].name

        if (this.fileName.lastIndexOf('.') <= 0) {
          return
        }
        const fr = new FileReader()
        fr.readAsDataURL(files[0])
        fr.addEventListener('load', () => {
          this.url = fr.result
          this.fileObject = files[0]
          this.onUploadSelectedFileClick()
        })

      } else {
        this.fileName = ''
        this.fileObject = null
        this.url = ''
      }
    },
    onUploadSelectedFileClick() {
      this.loading = true
      if (!this.fileObject) {
        alert('No file!!')
      }

      this.name = this.fileObject.name
      this.size = this.fileObject.size
      this.type = this.fileObject.type
      this.lastModifiedDate = this.fileObject.lastModifiedDate
      this.loading = false
    },
    clearForm() {
      this.note = ""
      this.fileName = ""
      this.name = ""
      this.fileObject = null
      this.type = null
      this.archType = ""
      this.loading = false
    },
    upload() {
      if (this.$refs.uploadFile.validate()) {
        this.loading = true


        let formData = new FormData()
        formData.append('file', this.fileObject)
        formData.append('fileName', this.fileName)
        formData.append('note', this.note)
        formData.append('type', this.type)
        formData.append('archType', this.archType)

        http.post('archives/upload', formData, {headers: {'Content-Type': 'multipart/form-data'}}).then((data) => {
          this.$emit("exit", data)
          this.clearForm()
        }).catch(() => this.$emit("exit", {"Status": "SS_Error"}))
      }
    }
  }
}


</script>

<style scoped>
</style>
